var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 8.92H20.25C21.2165 8.92 22 9.70798 22 10.68V23L17.625 18.6H10.625C9.6585 18.6 8.875 17.812 8.875 16.84V13.76M1 15.08V2.76C1 1.78798 1.7835 1 2.75 1H12.375C13.3415 1 14.125 1.78798 14.125 2.76V8.92C14.125 9.89202 13.3415 10.68 12.375 10.68H5.375L1 15.08Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationIcon);
export default __webpack_public_path__ + "static/media/conversationIcon.5cf64e2d0c089ca3bfb3e5794ba99f6e.svg";
export { ForwardRef as ReactComponent };